import { Component } from '@angular/core';

@Component({
    selector: 'my-app-main',
    template: require('./main.component.html'),
})
export class AppMainComponent {    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/main.component.ts